import React from 'react';
import { Paper, Grid } from '@material-ui/core';

import { SwissGroupItem } from './SwisGroupItem';
import items from './items';

export const SwissGroupGallery = () => (
  <Paper elevation={0} >
    <Grid container spacing={0}>
      {
        items.map(item => (
          <SwissGroupItem {...item} key={item.alt} />
        ))
      }
    </Grid>
  </Paper>
);

